export const maskIBAN = iban => {
    const last = iban.length - 1;
    const shouldMask = index => index >= 4 && index <= last - 4;

    const ibanArr = iban.split('');
    const masked = ibanArr.map((char, index) => (shouldMask(index) ? '*' : char)).join('');

    const groups = [];

    for (let i = 0; i < masked.length; i += 4) {
        groups.push(masked.slice(i, i + 4));
    }

    return groups.join(' ');
};
